<template lang="pug">
  .clusterize
    #scrollArea.clusterize-scroll
      table.tablex.fixed-header-table#contentArea.clusterize-content(style="width: auto;").mb-5
        thead.text-center
          tr
            th(style="width: 80px;")
              div {{ $t('ui.time') }}
            th(style="width: 450px;")
              div {{ $t('ui.event') }}
            th
              div {{ $tc('ui.odds', 1) }} / {{ $tc('ui.odds', 1) }}
            th
              div {{ $tc('ui.odds', 1) }} / {{ $t('ui.even') }}
            th
              div {{ $t('ui.even') }} / {{ $tc('ui.odds', 1) }}
            th
              div {{ $t('ui.even') }} / {{ $t('ui.even') }}
        tbody(v-for="(item, index) in cacheList")
          tr
            td(style="width: 80px;")
              div {{ item.mt == 'live'? item.rs : item.ed }}
              div {{ item.mt == 'live'? item.rt : item.et }}
            td(style="width: 450px;")
              div.text-info {{ item.th }}
              div.text-warning {{ item.ta }}
              div.text-danger {{ item.ln }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.oo_blink }") {{ item.oo }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.oe_blink }") {{ item.oe }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.eo_blink }") {{ item.eo }}
            td(style="width: 100px;").text-center
              div(:class="{'up': item.ee_blink }") {{ item.ee }}
</template>
<script>
export default {
  props: {
    value: {
      type: [String, Number],
      default: ""
    },
    cacheList: {
      type: Array,
      default: ""
    },
    betType: {
      type: String,
      default: ""
    },
    sportType: {
      type: String,
      default: ""
    },
    marketType: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    cleanup() {
      this.$forceUpdate();
    }
  }
};
</script>